export default{
    msg:'',
    trabalhador:'',
    tomador:'',
    aniversario:'',
    listahistorico:''
}